<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addDataParkHonor" v-if="permissionCodes.indexOf('029004001') !== -1"/>
        <!--<button-delete @deleteSelection="deleteSelection" />-->
      </div>
      <input-search placeholder="项目名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该要素？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />


  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/DataServicePark";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nError, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "upscale-elements",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "园区数据",
          name: "data-park-basic"
        },
        {
          value: "高端要素"
        }
      ],
      addDataParkHonor: "upscale-elements-add",
      operationArr: ["modify", "delete"],
      tableHead: [
        {
          prop: "tbrq",
          label: "填报日期"
        },
        {
          prop: "gqrs",
          label: "“国千/省千”人才数"
        },
        {
          prop: "fgrs",
          label: "硕士/副高以上人数"
        },
        {
          prop: "gjzl",
          label: "国家专利数量（件）"
        },
        {
          prop: "fmzl",
          label: "其中发明专利"
        },
        {
          prop: "cyjj",
          label: "吸引产业基金、风投基金等情况"
        }
      ],

      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      dialogFormVisible: false,
      videoInfo: {}
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      this.$axios
        .post(api.getParkHighEndPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {});
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },
    search(v) {
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    goToModifyPage(code) {
      this.$router.push({
        path: "/upscale_elements_modify/" + code
      });
    },

    deleteLine(code) {
      this.$axios
        .post(api.deleteParkHighEndByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    }
  },
  watch: {
    centEndTime(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.form-line {
  width: 420px;
  margin: 20px auto;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 122px;
  line-height: 32px;
  text-align: right;
}
.red {
  color: red;
}
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/view/DataServicePark/UpscaleElements/UpscaleElements.vue